import withQuery from 'with-query';

import { Region } from '../shared/types';
import { apiUrl } from './config';
import { getOption, RequestOptions } from './utils';

const getZoneGraphOptions = (region: Region): RequestOptions => ({
  url: withQuery(`${apiUrl}/zone/getZoneGraph`, { region }),
  ...getOption(),
});

const listZoneStocksOptions = (region: Region): RequestOptions => ({
  url: withQuery(`${apiUrl}/zone/listZoneStocks`, { region }),
  ...getOption(),
});

export default {
  getZoneGraphOptions,
  listZoneStocksOptions,
};
